import React from 'react';
import CoverImage from './CoverImage';
import About1 from './About1';
import Meal3 from './Meal3';
import Service1 from './Service1';
import Facility1 from './Facility1';
import Gallery1 from './Gallery1';
import VedioGallery from './VedioGallery';
import Beautycoco from './Beautycoco';




import Footer from './Footer';

const Home = () => {
    return (
        <div>
            <CoverImage />

            <About1 />
            <Beautycoco />
            <Meal3 />
            <Service1 />
            <Facility1 />
        <VedioGallery />
            <Gallery1 />


            <Footer/>
        </div>
    );
};

export default Home;
